import { render, staticRenderFns } from "./buscarContrato.vue?vue&type=template&id=128aeb2d&scoped=true&"
import script from "./buscarContrato.vue?vue&type=script&lang=js&"
export * from "./buscarContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128aeb2d",
  null
  
)

export default component.exports